import { Dispatch, SetStateAction, useRef, useState } from "react";

type UseReactiveRefReturn<T> = [
    T,
    Dispatch<SetStateAction<T>>,
    React.MutableRefObject<T>
];

export function useReactiveRef<T>(initialValue: T): UseReactiveRefReturn<T> {
    const [state, setState] = useState<T>(initialValue);
    const ref = useRef<T>(initialValue);

    const setReactiveState: Dispatch<SetStateAction<T>> = (value) => {
        const newValue = typeof value === "function" ? (value as (prev: T) => T)(ref.current) : value;
        ref.current = newValue;
        setState(newValue);
    };

    return [state, setReactiveState, ref];
}
